// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"399f508d0ed939ddf031","303":"c58ef6a63789d972b949","495":"33cbdc64765576a39dad"}[chunkId] + ".js";
};